import {hasPermission} from "@/helpers/permissions";
import {i18n} from "@/main"

export const getDisplayTextForApiLog = (apiLog: Record<string,any>): (string | null)[] => {
    let text = ['', '']

    // Groepeer logica o.b.v. controller classes
    if (apiLog.event.target_class === 'App\\Http\\Controllers\\Omt\\DispatchRequestController') {
        // Verdeel logica over controller functies
        switch (apiLog.event.target_action) {
            case 'overridePickupCode':
            case 'patchDispatchRequest':
            case 'replaceDispatchRequest':
                text = [
                    `Levering geüpdatet`,
                    `<small><i>Zie kolom 'geslaagd' voor details</i></small>`
                ];

                if (hasPermission('debug.allowed')) {
                    text[0] += ` <i><small>(${apiLog.event.target_action})</small></i>`
                }

                // TODO: Gaan we in een latere versie verbeteren™. Voor nu tonen we maar even een generieke tekst
                // carrier_id is redundant met carrier_method ipc. En carrier_id zal nooit wijzigen zonder dat carrier_method wijzigt.
                // const excludedAttributes = ['id', 'created_at', 'updated_at', 'identifier', 'status_reason', 'carrier_method_detail', 'carrier_id', 'dispatch_action']
                // const eventResultsToParse = (apiLog.event_results ?? []).filter((result: Record<string,any>) => result.is_successful)
                //
                // for (let i = 0; i < eventResultsToParse.length; i++) {
                //     text[1] += '<ul><li>'
                //     text[1] += _.map(eventResultsToParse[i].result.changed_attributes, (v, k): string => {
                //         if (excludedAttributes.includes(k)) {
                //             return '';
                //         }
                //
                //         switch (k) {
                //             case 'status':
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.filters.dispatch_request_status.title')}:</span> ` + i18n.t(`omt.gui.orders.dispatch-request-statuses.${v}`);
                //             case 'dispatch_type_id':
                //                 const dispatchType: Record<string,any> = Object.values(store.state.dispatchTypes).find((d: any) => d.id === v) as Record<string,any>
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.filters.dispatch_type.title')}:</span> ${dispatchType?.display_name}`;
                //             case 'dispatcher_identifier':
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.filters.dispatcher_identifier.title')}:</span> ${v}`;
                //             case 'responsible_location_id':
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.filters.responsible_location_identifier.title')}:</span> ${v}`;
                //             case 'dispatch_date':
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.columns.dispatch_date.title')}:</span> ${v}`;
                //             case 'dispatcher_type':
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.filters.dispatcher_type.title')}:</span> ${v}`;
                //             case 'carrier_method_id':
                //                 return `<span class="text-info">${i18n.t('frontend-filters.orders.filters.carrier_method.title')}:</span> ${v}`;
                //         }
                //
                //         return `<i class="text-info">${k}</i>: ${v}`
                //     })
                //         .filter(r => r)
                //         .join('</li><li>')
                //
                //     text[1] += '</li></ul>'
                // }

                return text;

            default:
                return [
                    i18n.t(`orders.event-results.${apiLog.event.target_class}.${apiLog.event.target_action}.description`).toString(),
                    i18n.t(`orders.event-results.${apiLog.event.target_class}.${apiLog.event.target_action}.action-description`).toString(),
                ]
        }
    }
    else if (apiLog.event.target_class === 'App\\Http\\Controllers\\Omt\\HoldReasonController') {
        switch (apiLog.event.target_action) {
            case 'updateHoldReason':
                let text: string[] = ['Blokkering gereviewed', '']
                switch (apiLog.event.payload.decision) {
                    case 'on-hold-released-manual':
                        text[1] = 'Goedgekeurd'
                        break;
                    case 'on-hold-final-manual':
                        text[1] = 'Definitief geblokkeerd'
                        break;
                    default:
                        text[1] = apiLog.event.payload.decision
                        break;
                }

                return text
        }
    }
    else {
        return [
            i18n.t(`orders.event-results.${apiLog.event.target_class}.${apiLog.event.target_action}.description`).toString(),
            i18n.t(`orders.event-results.${apiLog.event.target_class}.${apiLog.event.target_action}.action-description`).toString(),
        ]
    }

    return [`<i>${apiLog.event.request_summary}</i>`, null]
}
